'use client';
import { createContext, useContext } from 'react';
export const CopilotCtx = createContext(null);
export function useCopilot() {
    const ctx = useContext(CopilotCtx);
    if (!ctx) {
        throw new Error('useCopilot must be used inside <Copilot.Root>');
    }
    return ctx;
}
//# sourceMappingURL=context.js.map